import { literal } from '../typing/literal.js';
import { union } from '../typing/union.js';

export const InstanceType = union('InstanceType', [
  literal('stream'),
  literal('aggregation'),
]);
